import { Avatar, Button, Menu, Modal, Stack } from '@mantine/core'
import { IconSettings, IconUser } from '@tabler/icons'
import Cookies from 'js-cookie'
import { getText } from '../../utils/constants'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import CountryInput from '../inputs/country_input'
// import LanguageInput from '../inputs/language_input.js' // Eliminado
import { CpCountries } from '../platform_details.js'

// Eliminar variable locales y toda lógica relacionada con idioma

const LoggedOutMenu = () => {
  const [modalOpened, setModalOpened] = useState(false)
  const router = useRouter()
  const t = (key) => getText('Navbar', key)
  const country = router.locale?.split('-')[1]?.toLowerCase() || 'us'
  // const language = router.locale?.split('-')[0] // Eliminado
  const [selectedCountry, setSelectedCountry] = useState(country)
  // const [selectedLanguage, setSelectedLanguage] = useState(() => { ... }) // Eliminado
  // Eliminar: const selectedPlatforms = ...

  // Eliminar: const hitsCountries = ...

  // Eliminar: const platforms = ...

  useEffect(() => {
    // Cargar país seleccionado del contexto
    setSelectedCountry(country)

    // Cargar plataformas guardadas en localStorage
    const storedPlatforms = localStorage.getItem('selectedPlatforms')
    if (storedPlatforms) {
      // Eliminar: setSelectedPlatforms(JSON.parse(storedPlatforms))
    }
  }, [country])

  // Eliminar cualquier lógica relacionada con selectedLanguage y locales

  const handleCountryChange = (newCountry) => {
    setSelectedCountry(newCountry)
  }

  // Eliminar: const handlePlatformChange = ...

  const onClick = () => {
    setModalOpened(false)
    if (!selectedCountry) return

    // Todos los países usan solo inglés
    const newLocale = `en-${selectedCountry.toUpperCase()}`
    const consent = Cookies.get('cookie_consent') // Assuming you have saved consent here

    if (consent) {
      const consentObj = JSON.parse(consent) // Parse the stored JSON consent object

      // Only set the locale cookie if the user has consented to functional cookies
      if (consentObj.functional) {
        document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000`
      }
    }
    if (router.locale !== newLocale) {
      router.push(`/${newLocale}`)
    }
  }

  return (
    <>
      <Menu width={200}>
        <Menu.Target>
          <Avatar
            variant="gradient"
            radius="xl"
            src="/icon_user.png"
            size={35}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.3s ease, opacity 0.3s ease',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.1)' // Aumenta el tamaño al pasar el mouse
              }
            }}
          ></Avatar>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item disabled>{t('welcome')}</Menu.Item>
          <Menu.Divider />
          <Link href="/login" passHref>
            <Menu.Item component="a" icon={<IconUser size={14} />}>
              {t('login')}
            </Menu.Item>
          </Link>
          <Menu.Item
            icon={<IconSettings size={14} />}
            onClick={() => setModalOpened(true)}
          >
            {t('settings')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={t('settings')}
        centered
        size="md"
      >
        <Stack spacing={24} align="center">
          <CountryInput
            sx={{
              width: '80%',
              fontSize: '10px'
            }}
            label={t('country')}
            onChange={handleCountryChange}
            value={selectedCountry}
            filterCountries={CpCountries}
          />
          {/* <PlatformInput
            platforms={platforms}
            value={selectedPlatforms}
            onChange={handlePlatformChange}
            label={t('platforms')}
          /> */}
          <Button sx={{ backgroundColor: '#7B39B6' }} w={'80%'} onClick={onClick}>
            {t('save')}
          </Button>
        </Stack>
      </Modal>
    </>
  )
}

export default LoggedOutMenu
